import { c as _c } from "react/compiler-runtime";
import { useState, useCallback } from "react";
interface ToastState {
  message: string;
  isVisible: boolean;
}
interface UseToastReturn {
  message: string;
  isVisible: boolean;
  show: (message: string) => void;
  hide: () => void;
}
export function useToast() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      message: "",
      isVisible: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [toast, setToast] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = message => {
      setToast({
        message,
        isVisible: true
      });
      setTimeout(() => {
        setToast(_temp);
      }, 2000);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const show = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setToast(_temp2);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const hide = t2;
  let t3;
  if ($[3] !== toast.isVisible || $[4] !== toast.message) {
    t3 = {
      message: toast.message,
      isVisible: toast.isVisible,
      show,
      hide
    };
    $[3] = toast.isVisible;
    $[4] = toast.message;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp2(prev_0) {
  return {
    ...prev_0,
    isVisible: false
  };
}
function _temp(prev) {
  return {
    ...prev,
    isVisible: false
  };
}